import React, { type ReactNode, type JSX } from 'react';
import clsx from 'clsx';

interface DialerLayoutProps {
  children?: ReactNode;
  isTransferred: boolean;
}

const DialerLayout = ({ children, isTransferred }: DialerLayoutProps): JSX.Element => {
  return (
    <div className={clsx(
      'grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3 flex-1 min-h-0 overflow-hidden',
      isTransferred && 'grid-rows-[40px_170px_auto] md:grid-rows-[40px_170px_auto]',
    )}>
      {children}
    </div>
  );
};

export default DialerLayout;
